<template>
  <div>
    <NavTop :parentData="this.$route.params.tabBarId"></NavTop>
    <!-- 上面内容-->
    <div class="menu6_box_t content">
      <div class="box_t_l">
        <div class="t_l_img">
          <ul class="l_img_ul">
            <li class="l_img_img">
              <p>快捷通道</p>
              <p>EXPRESS LANE</p>
            </li>
            <li class="l_img_li" style="margin-bottom: 62px;" v-for="(item,index) in fastData" :key="index"
                @click="faskTo(item)">
              <div>
                <img :src="item.image" alt>
                <p>{{ item.name }}</p>
              </div>
            </li>
          </ul>
        </div>
        <div class="t_l_box">
          <div class="l_box_title">
            <span>{{ zhaoShengDT.childName }}</span>
            <span @click="routerTo(zhaoShengDT)">查看更多</span>
          </div>
          <div class="l_box_list">
            <ul class="list_ul">
              <li class="list_li" v-for="(item,index) in zhaoShengDT.articleList" :key="index">
                <div class="li_time">
                  <p>{{ getDayFromDateString(item.publishTime) }}</p>
                  <p>{{ getYearMonth(item.publishTime) }}</p>
                </div>
                <div class="li_title" @click="navigateTo(item)">
                  <span>{{ item.title }}</span>
                  <p></p>
                </div>
                <div class="li_a" @click="navigateTo(item)">
                  <img src="../../assets/images/right1.png" alt>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="box_t_r">
        <div class="t_r_t">
          <div class="t_title">
            <span>{{ zhongYaoTZ.childName }}</span>
            <span @click="routerTo(zhongYaoTZ)">查看更多</span>
          </div>
          <div class="t_list">
            <ul class="t_list_ul">
              <li class="t_list_li" v-for="(item,index) in zhongYaoTZ.articleList" :key="index"
                  @click="navigateTo(item)">
                <span>{{ item.title }}</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="t_r_b">
          <div class="t_title">
            <span>{{ luQuFS.childName }}</span>
            <span @click="routerTo(luQuFS)">查看更多</span>
          </div>
          <div class="t_list">
            <ul class="t_list_ul">
              <li class="t_list_li" v-for="(item,index) in luQuFS.articleList" :key="index" @click="navigateTo(item)">
                <span>{{ item.title }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- 招生政策 -->
    <div class="menu6_box2 content">
      <div class="box2_left">
        <div class="left_title">
          <span>{{ zhaoShengZC.childName }}</span>
          <span @click="routerTo(zhaoShengZC)">查看更多</span>
        </div>
        <div class="left_box">
          <ul class="left_box_ul">
            <li class="left_box_li" v-for="(item,index) in zhaoShengZC.articleList" :key="index">
              <span class="left_box_li1" @click="navigateTo(item)">{{ item.title }}</span>
              <div class="left_box_li2">{{ extractDate(item.publishTime) }}</div>
              <img @click="navigateTo(item)" src="../../assets/images/right1.png" alt>
            </li>
          </ul>
        </div>
      </div>
      <div class="box2_left">
        <div class="left_title">
          <span>{{ zhaoShengJH.childName }}</span>
          <span @click="routerTo(zhaoShengJH)">查看更多</span>
        </div>
        <div class="left_box">
          <ul class="left_box_ul">
            <li class="left_box_li" v-for="(item,index) in zhaoShengJH.articleList" :key="index">
              <span @click="navigateTo(item)" class="left_box_li1">{{ item.title }}</span>
              <div class="left_box_li2">{{ extractDate(item.publishTime) }}</div>
              <img @click="navigateTo(item)" src="../../assets/images/right1.png" alt>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import home from '../../api/home'
import child from '../../api/child'

export default {
  data () {
    return {
      parentData: '',
      // 招生动态对应索引
      dynamicIdx: -1,
      // 快捷通道数据
      fastData: [],
      // 招生动态数据
      zhaoShengDT: [],
      // 重要通知数据
      zhongYaoTZ: [],
      // 录取分数数据
      luQuFS: [],
      // 招生政策数据
      zhaoShengZC: [],
      // 招生计划数据
      zhaoShengJH: []
    }
  },
  created () {
    this.path = this.extractBasePath(this.$route.path)
    this.getLink(this.path)
    if (this.$route.params.tabBarId) {
      this.getWenZhang(this.$route.params.tabBarId)
    }
  },
  methods: {
    // 获取快捷通道数据
    async getLink (path) {
      try {
        const res = await child.getRealLink({path: path})
        this.fastData = res.data
        console.log(this.data, 'datadata')
      } catch (e) {
        console.log(e)
      }
    },
    // 获取内容
    async getWenZhang (tabBarId) {
      try {
        const res = await child.getChild({tabBarId: tabBarId})
        let data = res.data
        // 招生动态数据
        if (data[0]) {
          this.zhaoShengDT = data[0]
        }
        // 招生政策数据
        if (data[1]) {
          this.zhongYaoTZ = data[1]
        }
        // 录取分数数据
        if (data[2]) {
          this.luQuFS = data[2]
        }
        // 招生政策数据
        if (data[3]) {
          this.zhaoShengZC = data[3]
        }
        // 招生计划数据
        if (data[4]) {
          this.zhaoShengJH = data[4]
        }
        console.log(res)
      } catch (e) {
        console.log(e)
      }
    },
    // 快捷通道跳转
    faskTo (item) {
      if (item.path.startsWith('https')) {
        window.open(item.path, '_blank')
        return
      }
      this.$router.push(item.path + '/' + this.$route.params.tabBarId + '/' + item.tabBarId)
    },

    faskTo2 (path) {
      window.open(path, '_blank')
    },

    // 文章列表跳转
    navigateTo (item) {
      this.$router.push('/common/section/detail' + '/' + this.$route.params.tabBarId + '/' + item.tabBarId + '/' + item.id)
    },
    // 查看更多跳转
    routerTo (item) {
      this.$router.push('/common/section/more' + '/' + item.parentId + '/' + item.id)
    },
    // 招生动态鼠标移入
    medynamic (index) {
      this.dynamicIdx = index
    },
    // 招生动态鼠标移出
    mldynamic () {
      this.dynamicIdx = -1
    },
    // 截取日期
    extractDate (dateTimeStr) {
      // 使用空格分割日期和时间
      const parts = dateTimeStr.split(' ')
      // 返回日期部分
      return parts[0]
    },
    // 截取日份
    getDayFromDateString (dateString) {
      // 将日期字符串转换为Date对象
      const date = new Date(dateString)

      // 获取日部分，并返回
      return date.getDate().toString()
    },
    // 定义方法来截取年和月，并连在一起
    getYearMonth (date) {
      if (!date) {
        return ''
      }
      // 使用正则表达式匹配并返回年和月
      const match = date.match(/^(\d{4})-(\d{2})/)
      if (match) {
        return `${match[1]}-${match[2]}` // 将年和月连在一起返回
      }
      return '' // 如果没有匹配，返回空字符串
    },
    // 过滤路径
    extractBasePath (url) {
      // 使用正则表达式匹配路径，并在最后一个斜杠之前停止
      const match = url.match(/^(.*)\/\d+(?:\/\d+)?(?=\/|$)/)

      // 如果匹配成功，返回匹配的第一部分
      if (match && match[1]) {
        return match[1]
      }

      // 如果没有匹配到，返回原始 URL
      return url
    }
  }
}
</script>
<style lang="less" scoped>
.menu6_box_t {
  height: 770px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .box_t_l {
    width: 866px;
    height: 100%;
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .t_l_img {
      width: 195px;
      height: 800px;
      margin-top: 35px;
      z-index: 99;

      .l_img_ul {
        width: 100%;
        height: 100%;
        background: url(../../assets/images/menu6_left.png);
        background-size: 100% 100%;

        .l_img_img {
          width: 195px;
          height: 190px;
          margin-bottom: 20px;

          p {
            &:nth-child(1) {
              padding-top: 40px;
              font-size: 32px;
              color: #fff;
              font-weight: bold;
              width: 100%;
              text-align: center;
            }

            &:nth-child(2) {
              font-size: 16px;
              color: #fff;
              line-height: 32px;
              text-align: center;
            }
          }
        }

        .l_img_li {
          width: 195px;
          height: 88px;
          text-align: center;

          div {
            color: #666;

            img {
              position: relative;
              cursor: pointer;
              border: none;
            }

            p {
              line-height: 39px;
              font-size: 18px;
              color: #fff;
            }
          }
        }
      }
    }

    .t_l_box {
      width: 633px;
      height: 100%;

      .l_box_title {
        height: 90px;
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        border-bottom: 1px solid #eee;
        position: relative;

        span {
          &:nth-child(1) {
            font-size: 28px;
            color: #444;
            line-height: 54px;
            position: relative;

            &::after {
              content: "";
              position: absolute;
              width: 100%;
              height: 2px;
              background: #8d080e;
              bottom: 0;
              left: 0;
            }
          }

          &:nth-child(2) {
            cursor: pointer;
            color: #666;
            position: relative;
            line-height: 40px;
            font-size: 14px;
            padding-right: 20px;

            &::after {
              content: '';
              position: absolute;
              width: 8px;
              height: 8px;
              border: 1px solid #999;
              border-left: none;
              border-bottom: none;
              transform: rotate(45deg);
              top: 50%;
              margin-top: -5px;
              right: 7px;
            }
          }
        }
      }

      .l_box_list {
        width: 100%;
        height: 675px;
        overflow: hidden;

        .list_ul {
          width: 100%;
          height: 100%;

          .list_li {
            height: 111px;
            border-bottom: 1px solid #eee;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .li_time {
              width: 95px;
              position: relative;

              &::after {
                content: "";
                position: absolute;
                background: #eee;
                width: 1px;
                height: 100%;
                right: 0;
                top: 0;
              }

              p {
                &:nth-child(1) {
                  text-align: center;
                  font-size: 30px;
                  font-weight: bold;
                  color: #666;
                }

                &:nth-child(2) {
                  text-align: center;
                  line-height: 30px;
                  color: #666;
                }
              }
            }

            .li_title {
              width: 400px;
              padding: 0 30px;

              span {
                color: #000;
                display: block;
                line-height: 28px;
                text-decoration: none;
                overflow: hidden;
                cursor: pointer;
                white-space: nowrap;

                &:hover {
                  color: #8D080E;
                }
              }

              p {
                width: 100%;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                line-height: 30px;
                font-size: 14px;
                color: #999;
              }
            }

            .li_a {
              width: 50px;
              height: 50px;

              img {
                cursor: pointer;
                width: 100%;
                position: relative;
              }
            }
          }
        }
      }
    }
  }

  .box_t_r {
    margin-top: 84px;

    .t_r_t {
      width: 300px;
      height: 277px;
      border: 1px solid #eee;
      margin-bottom: 40px;

      .t_title {
        padding: 0 20px;
        height: 50px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        span {
          &:nth-child(1) {
            font-size: 28px;
            color: #444;
            line-height: 54px;
            position: relative;

            &::after {
              content: "";
              position: absolute;
              width: 100%;
              height: 2px;
              background: #8d080e;
              bottom: 2px;
              left: 0;
            }
          }

          &:nth-child(2) {
            font-size: 16px;
            cursor: pointer;
            color: #666;

            &:hover {
              color: #8D080E;
            }
          }
        }
      }

      .t_list {
        height: 220px;
        padding: 0 20px;
        overflow: hidden;

        .t_list_ul {
          width: 100%;
          height: 100%;
          padding-top: 10px;

          .t_list_li {
            height: 50px;
            padding-left: 20px;
            position: relative;
            border-bottom: 1px solid #eee;
            line-height: 50px;

            span {
              color: #333;
              display: block;
              text-decoration: none;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              font-size: 15px;
              cursor: pointer;

              &:hover {
                color: #8D080E;
              }

              &::after {
                content: "";
                position: absolute;
                width: 5px;
                height: 5px;
                background: #8d080e;
                border-radius: 50%;
                left: 0;
                top: 50%;
              }
            }
          }
        }
      }
    }

    .t_r_b {
      width: 300px;
      height: 390px;
      border: 1px solid #eee;
      margin-bottom: 40px;
      box-sizing: border-box;
      padding-bottom: 20px;
      overflow: hidden;

      .t_title {
        padding: 0 20px;
        height: 50px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        span {
          &:nth-child(1) {
            font-size: 28px;
            color: #444;
            line-height: 54px;
            position: relative;

            &::after {
              content: "";
              position: absolute;
              width: 100%;
              height: 2px;
              background: #8d080e;
              bottom: 2px;
              left: 0;
            }
          }

          &:nth-child(2) {
            cursor: pointer;
            color: #666;

            &:hover {
              color: #8D0835;
            }
          }
        }
      }

      .t_list {
        height: 330px;
        padding: 0 20px;
        overflow: hidden;
        padding-bottom: 21px !important;

        .t_list_ul {
          width: 100%;
          height: 100%;
          padding-top: 10px;
          overflow: hidden;

          .t_list_li {
            height: 50px;
            padding-left: 20px;
            position: relative;
            border-bottom: 1px solid #eee;
            line-height: 50px;
            cursor: pointer;

            span {
              color: #333;
              display: block;
              text-decoration: none;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              font-size: 15px;

              &:hover {
                color: #8D080E;
              }

              &::after {
                content: "";
                position: absolute;
                width: 5px;
                height: 5px;
                background: #8d080e;
                border-radius: 50%;
                left: 0;
                top: 50%;
              }
            }
          }
        }
      }
    }
  }
}

// 招生政策
.menu6_box2 {
  margin-top: 50px !important;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .box2_left {
    width: 555px;
    height: 365px;

    .left_title {
      height: 50px;
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      border-bottom: 1px solid #eee;
      position: relative;
      background: none !important;

      span {
        &:nth-child(1) {
          font-size: 28px;
          color: #444;
          line-height: 54px;
          position: relative;

          &:after {
            content: "";
            position: absolute;
            width: 100%;
            height: 2px;
            background: #8d080e;
            bottom: 0;
            left: 0;
          }
        }

        &:nth-child(2) {
          cursor: pointer;
          color: #666;
          position: relative;
          line-height: 40px;
          font-size: 14px;
          padding-right: 20px;

          &::after {
            content: "";
            position: absolute;
            width: 8px;
            height: 8px;
            border: 1px solid #999;
            border-left: none;
            border-bottom: none;
            transform: rotate(45deg);
            top: 50%;
            margin-top: -5px;
            right: 7px;
          }
        }
      }
    }
  }

  .left_box {
    width: 555px;
    height: 285px;
    overflow: hidden;
    margin-top: 10px;

    .left_box_ul {
      width: 100%;
      height: 100%;
      overflow: hidden;

      .left_box_li {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 56px;

        .left_box_li1 {
          height: 100%;
          line-height: 56px;
          display: block;
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          padding-left: 20px;
          position: relative;
          cursor: pointer;
          color: #666;

          &::before {
            content: "";
            position: absolute;
            width: 5px;
            height: 5px;
            background: #8d080e;
            border-radius: 50%;
            left: 4px;
            top: 45%;
          }

          &:hover {
            color: #8D080E;
          }
        }

        .left_box_li2 {
          width: 110px;
          font-size: 13px;
          color: #999;
        }

        img {
          width: 23px;
          cursor: pointer;
        }
      }
    }
  }
}

ul.ol, li {
  list-style: none;
}

.content {
  width: 1200px;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/views/Enrollment/index.vue